import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './TermsOfUseLinks.module.scss';

function TermsOfUseLinks() {
  const { t } = useTranslation() as any;
  return (
    <div className={styles.footerDescription}>
      {t('continue_terms')}
      <br /> <Link to="/termsUse">{t('terms_of_use')}</Link> {t('confirm_terms')}{' '}
      <Link to="/privacyPolicy">{t('privacy')}</Link>
    </div>
  );
}

export default TermsOfUseLinks;
